import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=463595a6&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=463595a6&prod&lang=less&scoped=true"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=463595a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463595a6",
  null
  
)

export default component.exports